import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectSpaceInfo } from '~src/app/selectors/SpaceInfoSelectors';

import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../../actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../utils/ConnectUtils';
import { AllServerUsersAndIdentitiesSpace,AllServerUsersAndIdentitiesSpaceDispatchProps,AllServerUsersAndIdentitiesSpaceOwnProps, AllServerUsersAndIdentitiesSpaceStateProps } from './AllServerUsersAndIdentitiesSpace';

const mapStateToProps: MapStateToProps<AllServerUsersAndIdentitiesSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllServerUsersAndIdentitiesSpaceDispatchProps> = (dispatch) => bindActionCreators({
    requestSpaceContents,
    updateBreadcrumbs
  }, dispatch);

export const ConnectedAllServerUsersAndIdentitiesSpace: React.ComponentClass<AllServerUsersAndIdentitiesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllServerUsersAndIdentitiesSpace);
